import { NgOptimizedImage } from '@angular/common'
import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Component({
  selector: 'app-login-layout',
  imports: [NgOptimizedImage, RouterOutlet],
  templateUrl: './login-layout.component.html',
})
export class LoginLayoutComponent {}
